import { Link } from 'react-router-dom';
import { leagueMeta, leagueOrder, siteInfo } from '@/lib/site';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center text-xl">
                <i className="ri-basketball-line" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-semibold tracking-wide text-background-50">
                  {siteInfo.name}
                </span>
                <span className="font-heading text-[10px] tracking-[0.24em] text-background-300 mt-1">
                  {siteInfo.englishName}
                </span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              专注 NBA、CBA 与国际篮球赛事的直播信息平台。提供赛事列表、开赛时间、直播状态与赛况演示，让你不错过每一场值得看的比赛。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-4 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-wider text-background-50 mb-3">
              联赛分类
            </h4>
            <ul className="space-y-2 text-sm">
              {leagueOrder.map((key) => (
                <li key={key}>
                  <Link
                    to={`/category/${key}`}
                    className="text-background-300 hover:text-accent-300 transition-colors"
                  >
                    {leagueMeta[key].name} 赛事直播
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-wider text-background-50 mb-3">
              站点导航
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 hover:text-accent-300 transition-colors">
                  赛事搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2024 {siteInfo.name} · 本站赛事信息与赛况为前端演示数据，未接入真实流媒体服务
          </p>
          <p className="text-xs text-background-400 flex items-center gap-1.5">
            <i className="ri-shield-check-line" />
            内容仅供赛事资讯参考
          </p>
        </div>
      </div>
    </footer>
  );
}